import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { FormModal } from "@/shared/components/FormModal";
import type { Position, PositionFormValues } from "../types";

interface PositionFormModalProps {
	open: boolean;
	editing: Position | null;
	isSubmitting: boolean;
	onCancel: () => void;
	onSubmit: (values: PositionFormValues) => void;
}

export function PositionFormModal({
	open,
	editing,
	isSubmitting,
	onCancel,
	onSubmit,
}: PositionFormModalProps) {
	const { t } = useTranslation("positions");
	const isEditing = editing !== null;

	return (
		<FormModal<PositionFormValues>
			open={open}
			title={isEditing ? t("form.editTitle", { name: editing.name }) : t("form.createTitle")}
			initialValues={isEditing ? { name: editing.name } : undefined}
			isSubmitting={isSubmitting}
			onCancel={onCancel}
			onSubmit={onSubmit}
		>
			<Form.Item
				name="name"
				label={t("form.nameLabel")}
				rules={[{ required: true, message: t("form.nameRequired") }]}
			>
				<Input placeholder={t("form.namePlaceholder")} />
			</Form.Item>
		</FormModal>
	);
}
